import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { getDisplayName, getRoleLabel } from '../../utils/userDisplay';

function Avatar({ name, size = 40 }) {
  const initials = name
    ? name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase()
    : 'A';
  return (
    <div
      className="rounded-full bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] text-white flex items-center justify-center font-black shrink-0 shadow-[var(--shadow-glow-green)]"
      style={{ width: size, height: size, fontSize: size * 0.32 }}
    >
      {initials}
    </div>
  );
}

export function DashboardNavbar() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [search, setSearch] = useState('');
  const displayName = getDisplayName(user) || 'Admin';

  return (
    <header className="sticky top-0 z-20 h-16 flex items-center justify-between px-6 bg-white/85 backdrop-blur-xl border-b border-[var(--border-strong)]">
      <div className="relative hidden md:block w-full max-w-[360px]">
        <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-[var(--fg4)] text-[20px] pointer-events-none">search</span>
        <input
          type="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t('dashboard.quickSearch')}
          className="w-full h-11 pl-11 pr-4 rounded-[var(--radius-sm)] border border-[var(--border-strong)] bg-white text-sm font-semibold text-[var(--fg1)] placeholder:text-[var(--fg4)] outline-none focus:border-[var(--brand-green)] focus:ring-4 focus:ring-[#1e9f6b]/15 transition-all"
        />
      </div>

      <div className="flex items-center gap-4 ml-auto">
        <button
          type="button"
          className="relative h-[42px] w-[42px] rounded-xl border border-[var(--border)] bg-white text-[var(--fg3)] flex items-center justify-center hover:border-[var(--brand-green)] transition-colors"
          aria-label="Bildirishnomalar"
        >
          <span className="material-symbols-outlined text-[22px]">notifications</span>
          <span className="absolute top-2 right-2 h-2 w-2 rounded-full bg-[var(--accent-red)] ring-2 ring-white" />
        </button>

        <div className="h-8 w-px bg-[var(--border-strong)] hidden sm:block" />

        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-extrabold text-[var(--fg1)] leading-tight">{displayName}</p>
            <p className="text-[11px] font-semibold text-[var(--fg3)]">{getRoleLabel(user) || t('dashboard.title')}</p>
          </div>
          <Link to="/profile">
            <Avatar name={displayName} size={40} />
          </Link>
        </div>
      </div>
    </header>
  );
}
